import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AllForHireComponent } from './all-for-hire.component';
import { AllForHireResolve } from './all-for-hire.resolve';

@NgModule({
  imports: [
    RouterModule.forChild([
      {
        path: 'all-for-hire/:waterBodyId',
        component: AllForHireComponent,
        resolve: {
          portal: AllForHireResolve,
        },
      },
    ]),
  ],
  exports: [RouterModule],
})
export class AllForHireRoutingModule {}
